import React, { useEffect, useState } from "react";
import axios from "axios";
import API_ENDPOINTS from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button } from "react-bootstrap";

export default function ChatPermissionManager() {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [canChatWithIds, setCanChatWithIds] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const ADMIN_ID = 1; // ID admin

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get(API_ENDPOINTS.getAllUsers);
      setUsers(res.data);
    } catch (error) {
      console.error("Lỗi lấy danh sách user:", error);
    }
  };

  const loadUserPermissions = async (userId) => {
    try {
      const res = await axios.get(API_ENDPOINTS.getUserPermissions(userId));
      let permissions = res.data;

      // Luôn chắc chắn Admin được phép
      if (!permissions.includes(ADMIN_ID)) {
        permissions.push(ADMIN_ID);
      }
      setCanChatWithIds(permissions);
    } catch (error) {
      console.error("Lỗi tải quyền chat:", error);
    }
  };

  const handleUserChange = (e) => {
    const userId = parseInt(e.target.value);
    setSelectedUserId(userId);
    loadUserPermissions(userId);
  };

  const togglePermission = (id, role) => {
    if (role === "Admin") return; // Không cho sửa Admin

    setCanChatWithIds((prev) => {
      if (prev.includes(id)) {
        return prev.filter((x) => x !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const savePermissions = async () => {
    if (!selectedUserId) {
      alert("Vui lòng chọn user trước khi lưu!");
      return;
    }

    try {
      const finalPermissions = canChatWithIds.includes(ADMIN_ID)
        ? canChatWithIds
        : [...canChatWithIds, ADMIN_ID];

      await axios.post(
        API_ENDPOINTS.setUserPermissions(selectedUserId),
        finalPermissions
      );

      alert("Cập nhật quyền chat thành công!");
      setShowModal(false);
    } catch (error) {
      console.error("Lỗi lưu quyền chat:", error);
      alert("Có lỗi xảy ra khi lưu quyền chat");
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Phân quyền chat user</h2>

      {/* Chọn user */}
      <div className="row mb-3">
        <div className="col-md-4">
          <label className="form-label">Chọn user:</label>
          <select
            className="form-select"
            onChange={handleUserChange}
            value={selectedUserId || ""}
          >
            <option value="">-- Chọn user --</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.userName}
              </option>
            ))}
          </select>
        </div>

        {/* Nút mở popup */}
        {selectedUserId && (
          <div className="col-md-2 align-self-end">
            <button
              className="btn btn-primary"
              onClick={() => setShowModal(true)}
            >
              Phân quyền
            </button>
          </div>
        )}
      </div>

      {/* Modal popup */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "1rem" }}>
            User được chọn chat
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="list-group">
            {users
              .filter((u) => u.id !== selectedUserId)
              .map((user) => (
                <label
                  key={user.id}
                  className="list-group-item list-group-item-action"
                  style={{ fontSize: "0.9rem" }}
                >
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={canChatWithIds.includes(user.id)}
                    onChange={() => togglePermission(user.id, user.role)}
                    disabled={user.role === "Admin"} // Không cho sửa Admin
                  />
                  {user.userName}{" "}
                  {user.role === "Admin" && (
                    <span className="badge bg-primary ms-2">Admin</span>
                  )}
                </label>
              ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Đóng
          </Button>
          <Button variant="success" onClick={savePermissions}>
            Lưu quyền chat
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
